import React from 'react'

import { DateRangeFilter } from '@lifebit-ai/lds'
import type { Dayjs } from 'dayjs'

type DateRangeValue = [Dayjs | null, Dayjs | null] | null

interface RequestedDateFilterProps {
  onApply: (dateStrings: string[]) => void
  onReset: () => void
}

export const RequestedDateFilter = ({ onApply, onReset }: RequestedDateFilterProps) => {
  return (
    <DateRangeFilter
      onApply={(dates: DateRangeValue) => {
        if (!dates || dates.some(date => !date)) {
          onApply([])
          return
        }

        onApply(dates.map(date => date!.toISOString()))
      }}
      onReset={onReset}
      label="Requested date"
    />
  )
}
